import { company, Flow, flowMeta, hero } from '../content/site';
import { FlowKey } from '../hooks/useFlow';
import { Arrow, Check, Doorway } from './Icons';
import './Hero.css';

type Props = {
  flowKey: FlowKey;
  onChoose: (flow: Flow) => void;
};

const routeBlurbs: Record<Flow, string> = {
  practice:
    'The whole business — goodwill, work in progress, files, your team, and the will bank with it.',
  willbank:
    'Custody of the wills only. Your practice carries on trading exactly as it is.',
};

export function Hero({ flowKey, onChoose }: Props) {
  return (
    <section className="hero" id="top">
      <div className="hero__backdrop" aria-hidden>
        <Doorway className="hero__watermark" strokeWidth={0.5} />
      </div>

      <div className="container hero__inner">
        <div className="hero__copy">
          <p className="hero__eyebrow">{hero.eyebrow}</p>

          <h1 className="hero__title">
            {hero.headlineLead}{' '}
            <span className="hero__subject" key={flowKey}>
              {hero.headlineSubject[flowKey]}
            </span>
          </h1>

          <p className="hero__tagline">{company.tagline}</p>
          <p className="hero__body">{hero.body}</p>

          <ul className="hero__proof">
            {hero.proofPoints.map((point) => (
              <li key={point} className="hero__proof-item">
                <Check className="hero__proof-icon" />
                {point}
              </li>
            ))}
          </ul>
        </div>

        <div className="hero__routes">
          <div className="routes">
            <p className="routes__label" id="routes-label">
              Which describes you?
            </p>

            <div className="routes__list" role="group" aria-labelledby="routes-label">
              {(['practice', 'willbank'] as Flow[]).map((flow) => (
                <button
                  key={flow}
                  type="button"
                  className={`route ${flowKey === flow ? 'is-active' : ''}`}
                  onClick={() => onChoose(flow)}
                >
                  <span className="route__title">
                    {flowMeta[flow].cta}
                    <Arrow className="route__arrow" />
                  </span>
                  <span className="route__blurb">{routeBlurbs[flow]}</span>
                </button>
              ))}
            </div>

            <a className="routes__aside" href="#compare">
              Not sure which applies to you? Compare the two
              <Arrow className="routes__aside-arrow" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
